"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NotificationsMenu = require("./NotificationsMenu");
Object.keys(_NotificationsMenu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotificationsMenu[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NotificationsMenu[key];
    }
  });
});
var _defaultTranslations = require("./constants/defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _defaultTranslationsWithNamespaces = require("./constants/defaultTranslationsWithNamespaces");
Object.keys(_defaultTranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _defaultTranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslationsWithNamespaces[key];
    }
  });
});
